import React from "react"
import { withRadium } from "higher-order-components"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { FlashMessge } from "components"
import { actionCreators, selectors } from "store/actions/mymazda"

const FlashMessageBanner = ({ messages, removeMessage }) => (
  <div>
    {messages.map((message, index) => (
      <FlashMessge
        key={message.id}
        index={index}
        onDismiss={() => removeMessage(message.id)}
        {...message} />
    ))}
  </div>
)

FlashMessageBanner.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    message: PropTypes.string
  })),
  removeMessage: PropTypes.func
}

const mapDispatchToProps = dispatch => ({
  removeMessage: (id) =>
    dispatch(actionCreators.removeFlashMessage(id))
})

const mapStateToProps = state => ({
  messages: selectors.getFlashMessages(state)
})


export default withRadium(connect(mapStateToProps, mapDispatchToProps))(FlashMessageBanner)



// WEBPACK FOOTER //
// ./src/containers/mymazda/navigation/flash-message-banner.jsx